export default __webpack_public_path__ + "static/media/valeurs.8cc8ec86.svg";